import { CampaignLayout } from '@ospace/campaign'
import { Notes, useNotesForCompany } from '@ospace/note'
import { ErrorBoundary } from '@ospace/shared'
import { Grid, Loader } from '@mantine/core'
import { useParams } from 'react-router-dom'

import { CompanyBox } from '../components/CompanyBox'
import { MinimalContactsTable } from '../components/MinimalContactsList'
import { useCompanies, useContactsForCompanies } from '../hooks/useContacts'

type CompanyDetailPageProps = { campaignId: number; companyId: number }

const NotesBox = (props: { campaignId: number; companyId: number }) => {
  const { isFetching, data: notes } = useNotesForCompany(props.campaignId, props.companyId)

  return isFetching ? (
    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '60vh' }}>
      <Loader color='blue' />
    </div>
  ) : notes.length > 0 ? (
    <Grid className={`card`}>
      <div className='card-header border-0'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3'>Call notes</span>
        </h3>
      </div>
      <div
        className={`card-body`}
        style={{
          overflow: 'auto',
        }}
      >
        <Notes notes={notes} />
      </div>
    </Grid>
  ) : (
    <></>
  )
}

const ContactBox = (props: { campaignId: number; companyId: number }) => {
  const { isFetching, data: contacts } = useContactsForCompanies(props.campaignId, props.companyId)
  return isFetching ? (
    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '60vh' }}>
      <Loader color='blue' />
    </div>
  ) : contacts.length > 0 ? (
    <Grid className={`card mb-4`}>
      <div className='card-header border-0'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3'>Contact List</span>
        </h3>
      </div>

      <MinimalContactsTable contacts={contacts} />
    </Grid>
  ) : (
    <></>
  )
}

export const CompanyDetailPage = (props: CompanyDetailPageProps) => {
  const {
    isFetching,
    data: { companies },
  } = useCompanies(props.campaignId)

  const company = companies.find((c: any) => c.id === props.companyId.toString())

  return (
    <CampaignLayout>
      {isFetching ? (
        <div
          className='d-flex align-items-center justify-content-center'
          style={{ minHeight: '60vh' }}
        >
          <Loader color='blue' />
        </div>
      ) : (
        <Grid>
          <Grid.Col span={4}>
            {company && <CompanyBox company={company} collpase={false} />}
          </Grid.Col>
          <Grid.Col span={8}>
            <ContactBox campaignId={props.campaignId} companyId={props.companyId} />
            <NotesBox campaignId={props.campaignId} companyId={props.companyId} />
          </Grid.Col>
        </Grid>
      )}
    </CampaignLayout>
  )
}

const Controller = () => {
  const params: any = useParams()
  const campaignId: number = Number(params?.id)
  const companyId: number = Number(params?.companyId)
  return <CompanyDetailPage campaignId={campaignId} companyId={companyId} />
}

export const CompanyDetailPageRouteHandler = () => (
  <ErrorBoundary>
    <Controller />
  </ErrorBoundary>
)
